import "./style.css";
import { useEffect, useState, forwardRef, useCallback } from "react";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Form, Row, Col } from "react-bootstrap";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import ButtonCom from "../../../components/button/button";
import { useDispatch, useSelector } from "react-redux";
import {
  commonGetDataOne,
  commonSaveData,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import { fetchBranchData } from "../../../redux/slices/branchSlice";
import { AgGridReact } from "ag-grid-react";
import {
  getEmployerIdListPath,
  createEmployerIdPath,
  updateEmployerIdPath,
} from "../../../services/config";
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import CustomPagination from "../../../components/CustomPagination";
import { HasPermission } from "../../../services/hasPermission";
// import { useGlobalToast } from'../../../stopOldToastGlobally';
import { useGlobalToast } from "../../../stopOldToastGlobally";


const EmployeeId = () => {
  const dispatch = useDispatch();

  const toast = useGlobalToast();

  const state = useSelector((state) => state.common);
  const branchState = useSelector((state) => state.branch);
// const toast = useGlobalToast();
  
  const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : [];

  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [employerIdNameList, setEmployeeIdList] = useState([]);
  const [filterEmployeeIdList, setFilterEmployeeIdList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [branchesList, setBranchesList] = useState([]);

  const [addEmployeeId, setAddEmployeeId] = useState({
    employerId: null,
    employerIdName: "",
    empIdNumber: "",
    userId: user.user_id,
  });
  const [isEdit, setIsEdit] = useState(false);

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const getEmpList = useCallback(() => {
    dispatch(commonGetDataOne(`${getEmployerIdListPath}${user.user_id}`));
  }, []);

  useEffect(() => {
    getEmpList();
  }, []);

  useEffect(() => {
    if (state.commonGetOneSuccess) {
      setEmployeeIdList(state.commonGetOneData);
      setFilterEmployeeIdList(state.commonGetOneData);
      dispatch(fetchBranchData());
      dispatch(initCommonState());
    }
    if (branchState.brnGetSuccess) {
      setBranchesList(branchState.brnGetData);
    }
  }, [state, branchState, dispatch]);

  const handleClose = () => {
    setAddEmployeeId((pre) => (
      {
        ...pre,
        employerId: null,
        employerIdName: "",
        empIdNumber: "",
      }
    ));

    setValidated(false);
    setOpen(false);
    setIsEdit(false)
  };

  const handleClickOpen = () => {
    setAddEmployeeId((pre) => ({
      ...pre,
      employerId: null,
      employerIdName: "",
      empIdNumber: "",
      userId: user.user_id,
    }));
    setOpen(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddEmployeeId({
      ...addEmployeeId,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      const body = {
        path: createEmployerIdPath,
        data: {
          empIdNumber: addEmployeeId.empIdNumber,
          employerIdName: addEmployeeId.employerIdName,
          userId: user.user_id,
        },
      };
      dispatch(commonSaveData(body));
    }
  };

  const handleEdit = (row) => {
    setIsEdit(true);
    setAddEmployeeId({
      ...addEmployeeId,
      employerIdName: row.employerIdName,
      employerId: row.employerId,
      empIdNumber: row.empIdFormat,
      userId: user.user_id,
    });
    setOpen(true);
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    let d = {
      path: updateEmployerIdPath,
      data: {
        employerIdName: addEmployeeId.employerIdName,
        userId: user.user_id,
        employerId: addEmployeeId.employerId,
        empIdNumber: addEmployeeId.empIdNumber,
      },
    };
    dispatch(commonSaveData(d));
    setOpen(false);
  };

  useEffect(() => {
    if (state.commonSuccess) {
      toast.success(state.commonMessage);
      setOpen(false);
      getEmpList();
      setIsEdit(false);

      setAddEmployeeId((pre) => (
        {
          ...pre,
          employerId: null,
          employerIdName: "",
          empIdNumber: "",
        }
      ));
      dispatch(initCommonState());
    }
    if (state.commonError) {
      toast.error(state.commonMessage);
      setOpen(false);
      getEmpList();
      setIsEdit(false);
      setAddEmployeeId({
        ...addEmployeeId,
        employerIdName: "",
      });
      dispatch(initCommonState());
    }
  }, [state.commonSuccess, state.commonError]);

 const columns = [
  {
    headerName: "S. No.",
    valueGetter: (params) => params.node.rowIndex + 1,
    width: 100,
    cellStyle: { 
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    headerClass: "text-center"
  },
  {
    headerName: "Employee ID",
    field: "employerIdName",
    flex: 1,
    minWidth: 200,
    cellStyle: { 
      display: "flex",
      alignItems: "center",
      paddingLeft: "16px"
    }
  },
  {
    headerName: "Actions",
    width: 150,
    cellStyle: { 
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    cellRenderer: (rowData) => {
      return (
        <>
          {HasPermission("Employee Id", "edit") ? (
            <div 
              className="Branches-table-button"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "12px",
                width: "100%"
              }}
            >
          <PiPencilSimpleLineBold
  className="edit-icon"
  style={{ 
    cursor: "pointer", 
    fontSize: "22px", // Standard icon size
    color: "#007bff",
    padding: "6px", // Minimal padding
    borderRadius: "4px",
    backgroundColor: "transparent",
    transition: "all 0.2s",
    width: "36px", // Compact container
    height: "36px", // Compact container
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }}
  onClick={() => handleEdit(rowData.data)}
  onMouseEnter={(e) => {
    e.target.style.backgroundColor = "#e8f4ff";
    e.target.style.transform = "scale(1.1)";
  }}
  onMouseLeave={(e) => {
    e.target.style.backgroundColor = "transparent";
    e.target.style.transform = "scale(1)";
  }}
/>
            </div>
          ) : (
            <span style={{ color: "#999" }}>-</span>
          )}
        </>
      );
    },
  },
];
  const paginationPageSize = 10;

  const preSubmitBsDtl = () => {
    let elem = document.querySelector("#form-save");
    if (elem) {
      elem.click();
    }
  };

  const searchEmployees = (val) => {
    setSearchQuery(val);
    const filteredEmployees = filterEmployeeIdList.filter(
      (v) =>
        v.employerIdName.toLowerCase().includes(val.toLowerCase()) ||
        v.employerId.toLowerCase().includes(val.toLowerCase())
    );
    setEmployeeIdList(filteredEmployees);
  };

  return (
    <div
      className="SettingBody"
      style={{
        position: "fixed",
        width: "calc(100%)",
        height: "100%",
        borderRadius: "7px",
        overflow: "auto",
        backgroundColor: "transparent",
      }}
    >
      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />

      <div className="Branches-container">
        <Widgets
          icon={
            <WidgetsIcon
              icon={
                <Link to="/setting/" className="icon-color">
                  <ArrowBackIcon />
                </Link>
              }
              title="Company Employee ID"
            />
          }
          button={
            HasPermission("Employee Id", "create") && (
              <ButtonCom
                type="button"
                class_name="border-radius-8px universal-btn"
                text="Add New Employee Id"
                url_or_onclick={handleClickOpen}
                icon={<AddIcon style={{ position: "relative", top: "-2px" }} />}
                width={""}
              />
            )
          }
          body={
            <>
              <div className="d-flex align-items-center justify-content-start gap-2 mt-3 px-3">
                <Form.Control
                  placeholder="Search Employee By Name and ID"
                  className="universal-input-one"
                  style={{ width: "250px" }}
                  value={searchQuery}
                  name="searchQuery"
                  onChange={(e) => searchEmployees(e.target.value)}
                />
                <Form.Select
                  className="universal-input-one"
                  style={{ width: "250px" }}
                >
                  <option>Job Title</option>
                </Form.Select>

                <Form.Select
                  className="universal-input-one"
                  style={{ width: "250px" }}
                >
                  <option>Job Type</option>
                </Form.Select>
                <Form.Select
                  className="universal-input-one"
                  style={{ width: "250px" }}
                >
                  <option>Branch</option>
                  {branchesList?.map((row, idx) => {
                    return (
                      <option value={row.branchId} key={idx}>
                        {row.branch_name}
                      </option>
                    );
                  })}
                </Form.Select>
              </div>

              <div
                className="ag-theme-quartz custom-grid"
                style={{
                  height: "calc(100vh - 240px)",
                  width: "100%",
                  padding: "20px",
                }}
              >
                <AgGridReact
                  rowData={
                    Array.isArray(employerIdNameList) ? employerIdNameList : []
                  }
                  columnDefs={columns}
                  omLayout="autoHeight"
                  pagination={true}
                  paginationPageSize={paginationPageSize}
                  onGridReady={onGridReady}
                />
              </div>
              <div className="d-flex align-items-center justify-content-between custom-pagination">
                {gridApi && <CustomPagination gridApi={gridApi} />}
              </div>
            </>
          }
        />
      </div>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={handleClose}>
              X
            </span>
            <span className="title">
              {isEdit ? "Update " : "Create "} Employee id
            </span>
          </div>
          <button className="universal-btn" onClick={preSubmitBsDtl}>
            {isEdit ? "Update " : "Add"}
          </button>
        </DialogTitle>
        <Form
          noValidate
          validated={validated}
          onSubmit={isEdit ? handleEditSubmit : handleSubmit}
        >
          <DialogContent>
            <Row>
              <Col sm="12">
                <Form.Group className="mb-2">
                  <Form.Label className="color-white">Employee ID</Form.Label>
                  <Form.Control
                    type="text"
                    name="employerIdName"
                    value={addEmployeeId.employerIdName}
                    placeholder="Enter Employee Id"
                    onChange={handleChange}
                    className="universal-input"
                    required
                  />
                  <Form.Control.Feedback type={"invalid"}>
                    Please provide valid employee id.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col sm="12">
                <Form.Group className="mb-2">
                  <Form.Label className="color-white">
                    Employer ID Number
                  </Form.Label>
                  <Form.Select
                    type="text"
                    name="empIdNumber"
                    value={addEmployeeId.empIdNumber}
                    onChange={handleChange}
                    className="universal-input"
                    required
                  >
                    <option value={""}>Select Employer Id Number</option>
                    <option value={"1"}>1</option>
                    <option value={"2"}>01</option>
                    <option value={"3"}>001</option>
                    <option value={"4"}>0001</option>
                  </Form.Select>
                  <Form.Control.Feedback type={"invalid"}>
                    Please provide valid employer id number.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </DialogContent>
          <DialogActions style={{ marginTop: "-10px" }}>
            <Button
              variant="contained"
              color="info"
              type="submit"
              style={{
                fontWeight: "300",
                fontSize: "14px",
                height: "30px",
                width: "100px",
                display: "none",
              }}
              className="universal-btn"
              id="form-save"
            >
              Save
            </Button>
          </DialogActions>
        </Form>
      </Dialog>
    </div>
  );
};

export default EmployeeId;